// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import PhotoVerificationActionType from './photo-verification.types';

const INITIAL_STATE = {
	// add photo response
	addPhotoResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** Member Photo Add Start ************************/
		case PhotoVerificationActionType.ADD_MEMBER_PHOTO_SUCCESS:
			return { ...state, addPhotoResponse: action.payload };

		case PhotoVerificationActionType.ADD_MEMBER_PHOTO_FAILURE:
			return { ...state, addPhotoResponse: action.payload };

		case PhotoVerificationActionType.ADD_MEMBER_PHOTO_RESPONSE_CHANGED:
			return { ...state, addPhotoResponse: null };

		/** ***************** Member Photo Add End ************************/

		default:
			return state;
	}
};
